import Badge from "components/Badge";

export const LEVEL = {
    HIGH: 3,
    MEDIUM: 2,
    LOW: 1
};

function ImpactBadge({level}) {
    switch (level) {
        case LEVEL.HIGH:
            return <Badge rounded color={'error'}>🔥High impact</Badge>
        case LEVEL.MEDIUM:
            return <Badge rounded color={'warning'}>⚡ Medium impact</Badge>
        case LEVEL.LOW:
            return <Badge rounded>❄ Low impact</Badge>
    }
}

export default ImpactBadge;
